import { searchParam } from '@luminovo/design-system';
import { ComponentMetricIdSchema } from '@luminovo/monitoring-contracts';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod/v4';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/component-savings')({
    // Access is enforced by the authenticated monitoring layout and the destination route.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({
        baseline: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        comparison: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        period: z.string().optional(),
        ipn: z.string().optional(),
    }),
    beforeLoad: () => {
        throw redirect({ to: '/monitoring/components/pricing', replace: true, search: true });
    },
});
